import type { ModuleFile } from '../../core/modules.ts';

// Módulo «settings»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'settings',
    title: 'Ajustes',
    path: 'ajustes',
    nav: { group: 'Sistema', label: 'Ajustes', icon: '⚙', order: 4 },
    load: () => import('./SettingsPage.tsx').then((m) => ({ default: m.SettingsPage })),
  },
];
